import { Clock } from "lucide-react";
import { Reveal, Rise } from "./Reveal";
import { scrollToId } from "../lib/scrollTo";
import content from "../content";

export default function WeekEvents() {
  const w = content.esteMes?.thisWeek;
  if (!w || w.hidden || !w.events?.length) return null;

  return (
    <div className="relative w-full max-w-7xl mx-auto px-6 mb-16 md:mb-24" data-testid="week-events">
      <Reveal>
        <Rise>
          <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1 mb-8">
            <h3 className="font-anton text-white text-3xl md:text-5xl uppercase leading-none">
              {w.label}
            </h3>
            {w.dateRange && (
              <span className="font-poppins text-electric text-sm md:text-base uppercase tracking-[0.2em] font-semibold">
                {w.dateRange}
              </span>
            )}
          </div>
        </Rise>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {w.events.map((e, i) => {
            const Card = e.link ? "button" : "div";
            return (
            <Rise key={`${e.dateNum}-${i}`}>
              <Card
                {...(e.link ? { type: "button", onClick: () => scrollToId(e.link) } : {})}
                className={`relative w-full text-left flex items-center gap-4 h-full rounded-2xl backdrop-blur-sm p-4 md:p-5 transition-colors duration-300 ${
                  e.highlight
                    ? "border border-electric/70 bg-electric/[0.12] shadow-[0_0_32px_-8px_rgba(33,112,232,0.7)] hover:bg-electric/20"
                    : "border border-white/10 bg-white/[0.05] hover:border-electric/40"
                } ${e.link ? "cursor-pointer" : ""}`}
                data-testid={`week-event-${i}`}
              >
                {e.tag && (
                  <span
                    className="absolute -top-2.5 right-4 rounded-full bg-electric px-2.5 py-1 font-poppins text-[10px] font-semibold uppercase tracking-[0.14em] text-white shadow-[0_0_14px_rgba(33,112,232,0.7)]"
                    data-testid={`week-event-tag-${i}`}
                  >
                    {e.tag}
                  </span>
                )}
                <div className="flex flex-col items-center justify-center rounded-xl bg-electric/10 border border-electric/25 px-3 py-2 min-w-[66px]">
                  <span className="font-poppins text-xs uppercase tracking-[0.12em] text-electric/90">{e.day}</span>
                  <span className="font-anton text-white text-3xl leading-none">{e.dateNum}</span>
                  {e.month && (
                    <span className="font-poppins text-[11px] uppercase tracking-[0.12em] text-ceramic/60">{e.month}</span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-poppins font-semibold text-white text-base md:text-lg leading-snug">
                    {e.title}
                  </h4>
                  {e.time && (
                    <p className="mt-1.5 inline-flex items-center gap-1.5 font-poppins text-electric text-sm md:text-base">
                      <Clock size={14} className="shrink-0" /> {e.time}
                    </p>
                  )}
                </div>
              </Card>
            </Rise>
            );
          })}
        </div>
      </Reveal>
    </div>
  );
}
